import { socketEmitEvent } from '../redux/actions'

let storeAPI = null;

class SocketService {
  static listeners = new Map()

  static emit(data) {
    storeAPI.dispatch(socketEmitEvent(data))
  }

  static setStore(store) {
    storeAPI = store;
  }

  static on(requestId, listener) {
    if (!this.listeners.has(requestId)) {
      this.listeners.set(requestId, new Set())
    }

    this.listeners.get(requestId).add(listener)

    return () => {
      const listeners = this.listeners.get(requestId)
      if (listeners) {
        listeners.delete(listener)
        if (listeners.size === 0) {
          this.listeners.delete(requestId)
        }
      }
    }
  }

  static handleResponse(response) {
    const { requestId } = response

    if (!requestId) {
      return
    }

    const listeners = this.listeners.get(requestId.toString())

    if (!listeners) {
      return
    }

    listeners.forEach((listener) => listener(response))
    this.listeners.delete(requestId.toString())
  }
}

export default SocketService
